import { CheckIcon, XMarkIcon } from '@heroicons/react/16/solid';
import clsx from 'clsx';
import Tooltip from 'components/layout/tooltip';
import { useState } from 'react';

type PromptParameterProps = {
  parameter: string;
  completed: boolean;
};

export default function PromptParameter({
  parameter,
  completed
}: PromptParameterProps) {
  const [copied, setCopied] = useState(false);

  const copyText = () => {
    navigator.clipboard.writeText(`{{${parameter}}}`);
    setCopied(true);
  };

  const classes = clsx(
    'relative flex items-center gap-[2px] rounded border-2 border-gray-300 bg-gray-200 py-1 pl-1 pr-2',
    completed ? 'border-green-300 bg-green-100' : 'border-red-300 bg-red-100'
  );

  return (
    <button
      type='button'
      className={classes}
      onClick={copyText}
      onMouseLeave={() => setCopied(false)}
    >
      {completed && <CheckIcon className='h-5 w-5 text-green-600' />}
      {!completed && <XMarkIcon className='h-5 w-5 text-red-600' />}
      <span className='text-sm font-semibold text-gray-900'>{parameter}</span>
      <Tooltip text={copied ? 'Copied!' : 'Copy to Clipboard'} />
    </button>
  );
}
